module.exports = __webpack_public_path__ + "media/images/views/home/home-section-quem-somos-top-fb718218f4c175442976b50cbb96ef45.png";